/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Select_Target_WarningInputs */

const en_options_backup_select_target_warning = /** @type {(inputs: Options_Backup_Select_Target_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a target location for automatic backups`)
};

const fr_options_backup_select_target_warning = /** @type {(inputs: Options_Backup_Select_Target_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner un emplacement cible pour les sauvegardes automatiques`)
};

const de_options_backup_select_target_warning = /** @type {(inputs: Options_Backup_Select_Target_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie einen Zielspeicherort für automatische Datensicherungen aus.`)
};

const it_options_backup_select_target_warning = /** @type {(inputs: Options_Backup_Select_Target_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una posizione di destinazione per i backup automatici`)
};

const ru_options_backup_select_target_warning = /** @type {(inputs: Options_Backup_Select_Target_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите целевое местоположение для автоматического резервного копирования.`)
};

const es_options_backup_select_target_warning = /** @type {(inputs: Options_Backup_Select_Target_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una ubicación de destino para las copias de seguridad automáticas`)
};

const zh_cn2_options_backup_select_target_warning = /** @type {(inputs: Options_Backup_Select_Target_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择自动备份的目标位置。`)
};

const ja_options_backup_select_target_warning = /** @type {(inputs: Options_Backup_Select_Target_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動バックアップの保存先を選択してください`)
};

const hi_options_backup_select_target_warning = /** @type {(inputs: Options_Backup_Select_Target_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया स्वचालित बैकअप के लिए लक्षित स्थान चुनें।`)
};

const pt_pt2_options_backup_select_target_warning = /** @type {(inputs: Options_Backup_Select_Target_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione um local de destino para backups automáticos.`)
};

/**
* | output |
* | --- |
* | "Please select a target location for automatic backups" |
*
* @param {Options_Backup_Select_Target_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_select_target_warning = /** @type {((inputs?: Options_Backup_Select_Target_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Select_Target_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_select_target_warning(inputs)
	if (locale === "de") return de_options_backup_select_target_warning(inputs)
	if (locale === "it") return it_options_backup_select_target_warning(inputs)
	if (locale === "ru") return ru_options_backup_select_target_warning(inputs)
	if (locale === "es") return es_options_backup_select_target_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_select_target_warning(inputs)
	if (locale === "ja") return ja_options_backup_select_target_warning(inputs)
	if (locale === "hi") return hi_options_backup_select_target_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_select_target_warning(inputs)
	return en_options_backup_select_target_warning(inputs)
});